import React, { createContext, useReducer } from "react";

import {teamContextReducer} from "./Reducers/TeamContext.reducer";

const defaultValues = {
    currentTeams: {
        teamId: null,
    },
    dispatchTeamsContext: () => {},
};

export const TeamsContext = createContext(defaultValues);

const TeamsContextProvider = (props) => {
    const [currentTeams, dispatchTeamsContext] = useReducer(
        teamContextReducer,
        defaultValues.currentTeams
    );

    return (
        <TeamsContext.Provider value={{ currentTeams, dispatchTeamsContext }}>
            {props.children}
        </TeamsContext.Provider>
    );
};

export { TeamsContextProvider };
